/* The function passed to throttle as argument will only be called at a maximum rate determined
 * by the browser's refresh rate, thanks to requestAnimationFrame. This significantly reduces the
 * number of times the expensive layout calculations are performed, improving performance during
 * window resizing.
 */
export const throttle = (func: () => void) => {
  let requestId: number | null = null;
  const throttled = function () {
    if (!requestId) {
      requestId = requestAnimationFrame(() => {
        func();
        requestId = null;
      });
    }
  };
  throttled.cancel = () => {
    if (requestId) {
      cancelAnimationFrame(requestId);
      requestId = null;
    }
  };
  return throttled;
};
